// A UUID that works on plain-HTTP pages too. `crypto.randomUUID` only exists in secure contexts,
// and boardroomforcreatives.com serves inner pages over http:// without redirecting, so calling it
// directly threw on those pages right after POST /session succeeded (incident 2026-10-09, see
// docs/plans/2026-10-09-session-start-incident-fixes.md). `crypto.getRandomValues` has no
// secure-context requirement, so the fallback builds the same RFC 4122 v4 shape from it.

export function randomId(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // RFC 4122 variant
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
